import modifyTemplate from '#shared/util/modifyTemplate.js';

import defaultTemplate from '#themes/default/default/layouts/pageLayout/pageLayout.html' with { type: 'html' };

import defaultPageLayout from '#themes/default/default/layouts/pageLayout/pageLayout.js';

import pageLayoutTemplate from './html/pageLayout.html' with { type: 'html' };

const template = modifyTemplate(defaultTemplate, [{
	query: '.pageLayout',
	position: 'replace',
	content: pageLayoutTemplate
}]);

export default {
	extends: defaultPageLayout,
	template
};
